import React, { FC } from 'react';
import { ListItem, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useStyles } from '../styles';

interface MainMenuItemProps {
  name: string;
  link?: string;
}

export const SubMenuItem: FC<MainMenuItemProps> = ({ name, link }) => {
  const classes = useStyles();

  return (
    <ListItem key={name} component={Link} to={link || ''} className={classes.subListItem}>
      <Button className={classes.subMenuButton}>{name}</Button>
    </ListItem>
  );
};
